import React from 'react';

import ShippingRateCardsEdit from '@pages/operator/ShippingRateCards/Edit';

// ShippingRateCardsEdit 目前為無 props 的自包含表單，內部依 id 切換 new/edit 模式。
// 此薄包裝僅為統一 /new 路由使用 New.jsx 的慣例，未來如需於新增模式注入額外設定可在此擴充。
export default function OperatorShippingRateCardNew() {
  return <ShippingRateCardsEdit />;
}
